import React from 'react';
import Header from "../thema/tema1/component/Header";
import Footer from "../thema/tema1/component/Footer";
import SideMenu from "../thema/tema1/component/SideMenu";
import PageContext from "../thema/tema1/component/PageContext";
import CustomModal from "../thema/tema1/component/CustomModal";
import Properties from "../const/Properties";
import CustomTable from "../thema/tema1/component/CustomTable"
import jsPDF from "jspdf";
import axios from 'axios';

const active = {Home: "active"};
const durumlar = {
    1: "Araç Limana Giriş Yaptı",
    2: "Ek Bilgi Girişi Yapıldı",
    3: "Ücret Belirlendi",
    4: "Ücret Alındı",
    5: "Gemiye Yüklendi",
};
class Muhasebe extends React.Component {
    componentDidMount() {

    }
    constructor(props){
        super(props);
        if(localStorage.getItem("token")=="")
        {
            window.location = '/';
            return false;
        }
        this.state = {
            showFatura:false,
            firmaId: 0,
            dorsePlaka: "",
            cekiciPlaka: "",
            tarih: "",
            firmalar: [],
            muhasebefirmalar: [],
            tasimalar: [],
            content: [],
            pageCount: 0,
            totalRow: 0,
            startRow: 0,
            endRow: 0,
            silId: 0,
            duzenleId: 0,
            makbuzId: 0,
            makbuzDurum: 0,
            silModal: 'none',
            title: ["TIR PLAKA","DURUMU","İŞLEM ÜCRETİ","GİDER ÜCRETİ", "İŞLEMLER"],
            showDuzenle: false,
            duzenle: false,
            error: 0
        };
        this.handlePageClick({selected:0});
        this.getTotalRow();
        this.muhasebefirmalarDoldur();
    }
    muhasebefirmalarDoldur = () => {
        axios({
            method: 'get',
            url: Properties.baseUrl + '/muhasebefirma/getAll',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                let muhasebefirmalar = res.data.map((item) =>
                    <option value={item.id}>{item.firmaAdi}</option>);
                this.setState({muhasebefirmalar: muhasebefirmalar});
            })
    }
    faturaGirisi = (e)=>{
        window.location = '/faturabelirleme/'+e;
        //this.setState({showFatura:true});
    }
    iptal = (e)=>{
        this.setState({showFatura:false});
    }
    makbuzYazdir = (e)=>{
        const doc = new jsPDF();
        doc.text("GEMİ ÜCRETİ 100 €", 10, 10);
        doc.text("BAF 10 €", 10, 10);
        doc.text("FOKLİFT 10 €", 10, 20);
        doc.save("myPDF.pdf");
        window.disableModal();
    }
    kayitKapat = (e)=>{
        window.disableModal();
        axios({
            method: 'post',
            url:  Properties.baseUrl+'/tasima/changeDurum',
            headers: {
                "Content-Type": "application/json",
                "Authorization" : "Bearer " + localStorage.getItem("token")
            },
            data: {
                id: this.state.makbuzId,
                durum: this.state.makbuzDurum,
            }
        })
            .then(res => {
                this.handlePageClick({selected:0});
                window.successful((this.state.showDuzenle?"Kayıt Kapatma Güncellendi.":"Kayıt Kapatma Kaydedildi"));
            }).catch(res =>{
                window.unsuccessful((this.state.showDuzenle?"Kayıt Kapatma Güncellenemedi.":"Kayıt Kapatma Kaydedilemedi."));
        });
        this.handlePageClick({selected:0});
        this.getTotalRow();
    }
    getTotalRow = ()=>{
        axios({
            method: 'get',
            url: Properties.baseUrl+'/tasima/toplam/',
            headers: {
                "Content-Type": "application/json",
                "Authorization" : "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                this.setState({totalRow:res.data});
                this.setState({pageCount:res.data/10});
            });
    }
    durumGuncelle = (id,durum) => {
        this.setState({makbuzId:id});
        this.setState({makbuzDurum:durum});
    }
    handlePageClick=e=>{
        this.setState({ startRow: (e.selected*10)+1});
        this.setState({ endRow:((e.selected+1)*10)});
        axios({
            method: 'get',
            url: Properties.baseUrl+'/tasima/sayfaliGetirMuhasebe/'+e.selected,
            headers: {
                "Content-Type": "application/json",
                "Authorization" : "Bearer " + localStorage.getItem("token")
            }
        })
            .then(res => {
                var getData = [];
                res.data.forEach(function (eleman) {
                    var elemanIc = new Object;
                    elemanIc.id = eleman.id;
                    elemanIc.cekiciPlaka = eleman.cekiciPlaka;
                    elemanIc.tarih = eleman.tarih;
                    getData.push(eleman);
                });
                this.setState({tasimalar:getData});
                let content = getData.map((item) =>
                                 (<tr>
                                    <td>{item.cekiciPlaka}</td>  
                                    <td>{durumlar[item.durum]}</td>  
                                    <td>{item.gelir} €</td>  
                                    <td>{item.gider} €</td>
                                     <td>
                                         <div className="row">
                                             <div className="col-3">
                                                 <button type="button" onClick={e => this.faturaGirisi(item.id)}
                                                         className="btn btn-block btn-outline-info">FATURA GİRİŞ
                                                 </button>
                                             </div>
                                             <div className="col-3">
                                                 <button type="button" onClick={e => this.durumGuncelle(item.id, 6)}
                                                         className="btn btn-block btn-outline-primary"
                                                         data-toggle="modal"
                                                         data-target="#kayit-modal">KAYDI KAPAT
                                                 </button>
                                             </div>
                                         </div>


                                     </td>
                                 </tr>));
                this.setState({content: content});
            });
    }

    render(props) {
        const button = {
            marginTop: "0px",
            marginLeft: "10px",
            float: "left",
            width: "100px"
        };
        return (
            <div>
                <Header/>
                <SideMenu muhasebe="active"/>
                <PageContext>
                    <form>
                        <div className="card card-primary" style={this.state.showFatura?{display:'block'}:{display:'none'}}>
                            <div className="card-header">
                                <h3 className="card-title">41 ST 203 Fatura Girişi</h3>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-6">
                                        <label>Kalem Adı</label>
                                        <select name="dersId" className="form-control select2">
                                            <option value={0} selected="selected">Kalem Seç</option>
                                            <option value={0}>Foklift</option>
                                            <option value={0}>Baf</option>
                                            <option value={0}>Gemi</option>
                                        </select>
                                    </div>
                                    <div className="col-6">
                                        <label htmlFor="exampleInputEmail1">Fatura Tutarı</label>
                                        <input type="text" className="form-control" id="sinifadi"
                                               placeholder="Fatura Tutarı"/>
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer row">
                                <div className="col-1">
                                    <button type="submit"  onClick={e=>this.iptal(e)} className="btn btn-block btn-primary">Kaydet</button>
                                </div>
                                <div className="col-1">
                                    <button type="button" onClick={e=>this.iptal(e)} className="btn btn-block btn-outline-info">İPTAL</button>
                                </div>
                            </div>
                        </div>

                    </form>
                    <div className="card">
                    <div className="card-header">
                        <h3 className="card-title">
                                <button style={button} type="button"
                                        className="btn btn-block btn-outline-primary">TÜMÜNÜ YAZDIR
                                </button>
                            </h3>
                        </div>
                        <div className="card-body">
                        <CustomTable state={this.state} getTotalRow={this.getTotalRow} handlePageClick={this.handlePageClick}></CustomTable>
                        </div>
                    </div>
                </PageContext>
                <Footer/>
                <CustomModal  id={"makbuz-modal"} funcModal={this.makbuzYazdir} title={"Makbuz Çıktı"} content={"Makbuz Çıktı Alınsın mi?"}></CustomModal>
                <CustomModal  id={"kayit-modal"} funcModal={this.kayitKapat} title={"Kayıt Kapat"} content={"Kayıt Kapatılsın mi?"}></CustomModal>
            </div>);
    }
}


export default Muhasebe;
